import { APIReferenceType } from '@ardoq/api-types';

export type LegendReferenceType = Omit<APIReferenceType, 'id'> & {
  globalTypeIds: string[];
  className: string;
  isSelected?: boolean;
};

type LegendReferenceTypeReducerState = {
  result: LegendReferenceType[];
  keyedResults: Map<string, LegendReferenceType>;
  /** whether or not to consider reference types distinct if they have different end caps. set this to false if you're displaying the legends as color swatches. */
  considerLineCaps: boolean;
};
const legendReferenceTypeKey = (
  referenceType: APIReferenceType,
  considerLineCaps: boolean
) =>
  `${referenceType.name}~~${referenceType.color}~~${referenceType.line}${
    considerLineCaps
      ? `~~${referenceType.lineBeginning}~~${referenceType.lineEnding}`
      : ''
  }`;
export const reduceLegendReferenceTypes = (
  state: LegendReferenceTypeReducerState,
  referenceType: APIReferenceType & { globalTypeId: string; className: string }
) => {
  const distinctKey = legendReferenceTypeKey(
    referenceType,
    state.considerLineCaps
  );
  const existing = state.keyedResults.get(distinctKey);
  if (existing) {
    existing.globalTypeIds.push(referenceType.globalTypeId);
  } else {
    const newEntry = {
      ...referenceType,
      globalTypeIds: [referenceType.globalTypeId],
    };
    state.result.push(newEntry);
    state.keyedResults.set(distinctKey, newEntry);
  }
  return state;
};
